import { FaArrowRightLong } from 'react-icons/fa6'
import { PropTypes } from 'prop-types'
import { motion } from 'framer-motion'
import Captcha from '../captcha'
import { useState } from 'react'

const Form = ({
  handleSubmit,
  modalOpen,
  open,
  closed,
  onLoading,
  children
}) => {
  const [formValid, setFormValid] = useState(false)

  const [submitAttempted, setSubmitAttempted] = useState(false)

  const onSubmit = e => {
    e.preventDefault()
    setSubmitAttempted(true)
    
    if (formValid) {
      handleSubmit(e)
    }
  }

  return (
    <>
      <form
        onSubmit={onSubmit}
        className='grid grid-cols-1 gap-3 w-full md:grid-cols-2 md:gap-x-8 md:gap-y-8'
      >
        {children}
          <Captcha  onValidate={setFormValid} 
            submitAttempted={submitAttempted} />
        <div className='flex flex-col md:flex-row gap-4 md:gap-0 my-3 md:my-0 md:items-center justify-between md:col-span-2'>
          <div className='flex items-start max-w-4xl gap-3'>
            <input
              type='checkbox'
              className='w-5 h-5 mt-1 accent-red-700'
              required
            />

            <div className='flex items-center gap-2'>
              <span>I or the representative (for students under the age of 18 years old) hereby have read the 
              <motion.button
                  type='button'
                  whileHover={{ scale: 1.01, textDecoration: 'underline' }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => (modalOpen ? closed() : open())}
                >
                  <span className='font-bold mx-1'>
                Privacy Policy
                </span>
                </motion.button>
                , understand, agree and consent for Universiti Tenaga Nasional to collect and use my 
                <motion.button
                  type='button'
                  whileHover={{ scale: 1.01, textDecoration: 'underline' }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => (modalOpen ? closed() : open())}
                >
                  <span className='font-bold mx-1'>
                Personal Data
                </span>
                </motion.button>
                .</span>
             
            </div>
          </div>
          <button
            type='submit'
            disabled={onLoading}
            className='bg-red-700 text-white px-6 py-3 rounded-md flex items-center gap-2 disabled:opacity-75 disabled:cursor-not-allowed'
          >
            {onLoading ? (
              <div className='px-8 flex items-center'>
                <span className='rounded-full w-8 h-8 bg-red-700 border-t-[4px] animate-spin border-white '></span>
              </div>
            ) : (
              <>
                Submit <FaArrowRightLong />
              </>
            )}
          </button>
        </div>
      </form>
    </>
  )
}
Form.propTypes = {
  handleSubmit: PropTypes.func,
  onLoading: PropTypes.bool,
  modalOpen: PropTypes.bool,
  open: PropTypes.func,
  closed: PropTypes.func,

  children: PropTypes.node
}
export default Form
